import { Dispatch, DispatchResponse, IReduxAction } from '../reducers'
import { ErrorAction } from '../reducers/errorReducer'

function isPromise(obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function'
}

// Intercepts all promised exceptions that occur in Redux.
const errorMiddleware = () => (dispatch: Dispatch) => (action: IReduxAction) => {
    if (!isPromise(action.payload)) {
        // This action is not a promise, continue as is.
        return dispatch(action)
    }

    // Dispatch initial pending promise, but intercept any errors?.
    return (
        dispatch(action)
            // When we get any valid response from Axios, it means that any network disruption has been resolved.
            .then((response: DispatchResponse) => {
                dispatch({ type: ErrorAction.DismissNetworkError })

                return response
            })
    )
}

export default errorMiddleware
